// Dashboard's own pages: the day, then the three reads the day links out to.
//
// THEY WERE NEVER RAIL ITEMS, AND THAT WAS THE WHOLE PROBLEM. Reconciliation,
// consent and the survey keep their own urls and their own report_access rows —
// ReportNav's header still argues why they are not siblings of Dashboard. What
// they were missing is the thing Registration's six pages have: when you are
// on one of them, the rail still says which section you are in, and the nested
// list says which page. Without that, Survey answers is a heading on a screen
// whose rail has gone quiet, and the only way back is the browser's.
//
// Shaped like RegistrationNav rather than sharing a component with it, for the
// reason RideNav gives: the common markup is four lines and the page type is
// not.

import type { ReactNode } from "react";
import type { ReportName } from "../api/endpoints.js";

export type DashboardPage = Extract<ReportName, "operator" | "optIn" | "reconciliation" | "survey">;

export type DashboardNavProps = {
  readonly page: DashboardPage;
  readonly onOpen: (page: DashboardPage) => void;
};

export const DASHBOARD_NAV_ITEMS: readonly {
  readonly page: DashboardPage;
  readonly label: string;
}[] = [
  { page: "operator", label: "Today" },
  { page: "optIn", label: "Consent" },
  { page: "reconciliation", label: "Arrivals" },
  { page: "survey", label: "Survey answers" },
];

export function dashboardPage(here: string): DashboardPage | null {
  for (const item of DASHBOARD_NAV_ITEMS) {
    if (item.page === here) return item.page;
  }
  return null;
}

export function DashboardNav({ page, onOpen }: DashboardNavProps): ReactNode {
  return (
    <nav className="sub" aria-label="Dashboard pages">
      {DASHBOARD_NAV_ITEMS.map((item) => (
        <button
          key={item.page}
          type="button"
          aria-current={item.page === page ? "page" : undefined}
          onClick={() => onOpen(item.page)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
